import { useEffect } from "react";

import useRestMutation from "@/remoteState/useRestMutation";
import { IAgathaSchema } from "@/search/NewSearchPageMVP/types/IAgathaSchema";
import { AGATHA_ORIGIN } from "@/search/search.constants";

const useFetchAgathaSchema = () => {
  const resource = `${AGATHA_ORIGIN}/api/schema/`;

  const [fetchAgathaSchema, { data: agathaSchema }] = useRestMutation(resource);

  useEffect(() => {
    fetchAgathaSchema();
  }, []);

  return agathaSchema as IAgathaSchema;
};

useFetchAgathaSchema.displayName = "useFetchAgathaSchema";
export { useFetchAgathaSchema };
